import type { IconProps } from '.';

/**
 * Globe Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const GlobeIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM12.8304 20.527C12.4697 20.9085 12.1887 21 12 21C11.8113 21 11.5303 20.9085 11.1696 20.527C10.8068 20.1435 10.4341 19.5348 10.1 18.6997C9.47611 17.1398 9.05559 14.9622 9.00511 12.5H14.9949C14.9444 14.9622 14.5239 17.1398 13.9 18.6997C13.5659 19.5348 13.1932 20.1435 12.8304 20.527ZM14.9949 11.5H9.00511C9.05559 9.03783 9.47611 6.86017 10.1 5.30032C10.4341 4.46523 10.8068 3.85653 11.1696 3.47296C11.5303 3.0915 11.8113 3 12 3C12.1887 3 12.4697 3.0915 12.8304 3.47296C13.1932 3.85653 13.5659 4.46523 13.9 5.30032C14.5239 6.86017 14.9444 9.03783 14.9949 11.5ZM15.9951 12.5C15.9244 16.0895 15.0966 19.1814 13.9026 20.7985C17.8018 19.9594 20.7622 16.594 20.9863 12.5H15.9951ZM20.9863 11.5H15.9951C15.9244 7.91047 15.0966 4.81861 13.9026 3.20149C17.8018 4.04065 20.7622 7.40597 20.9863 11.5ZM8.00491 11.5C8.07561 7.91047 8.90338 4.81861 10.0974 3.20149C6.19822 4.04065 3.23783 7.40597 3.01365 11.5H8.00491ZM3.01365 12.5C3.23783 16.594 6.19822 19.9594 10.0974 20.7985C8.90338 19.1814 8.07561 16.0895 8.00491 12.5H3.01365Z"
      fill="white"
    />
  </svg>
);

export default GlobeIcon;
